export interface IArtistSort {
  name: string;
  key: string;
  sortOrder: 'ascend' | 'descend' | '';
}

